import {defineStore} from "pinia"
import {ref, Ref} from "vue"
import {useConfigStore} from "../../app"
import {CrudListOptions} from "@hc/graphql"

export function defineSchemaStore<
  T,
  TInsert,
  TUpdate,
  TWhere,
  TOrder
>(collection: string) {
  return defineStore(collection, () => {
    const config = useConfigStore()
    const api = config.api.crudCollection(collection)
    const list = ref<Array<T>>(null)
    const loading = ref<boolean>(false)
    const params = ref<CrudListOptions<TWhere, TOrder>>(null) as Ref<CrudListOptions<TWhere, TOrder>>

    async function load(loadParams?: CrudListOptions<TWhere, TOrder>) {
      console.log("STORE LOAD", loadParams)
      loading.value = true
      params.value = loadParams
      const result = await api.list(loadParams)
      list.value = result
      console.log("STORE fetched", result)
      loading.value = false
      return result
    }

    return {list, load, params, loading}
  })
}